// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2Jqzz","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2pe8O"};